import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Menu, MenuItem } from "@material-ui/core";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"

import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"


import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Calendar from "react-modern-calendar-datepicker";

import LinearProgress from "@material-ui/core/LinearProgress"

import RequestSmsReceiver from "./RequestSmsReceiver";
import FloatingLabelInput from "./FloatingLabelInput";
import FilterPanel from "./FilterPanel";
import Grow from "@material-ui/core/Grow";
import Pagination from "@material-ui/lab/Pagination";
import MarketerBaseState from "./MarketerBase/MarketerBaseState";

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    progress: {
        width: '100%',
        height: 10, // ارتفاع نوار درصد
    },
    progressContainer: {
        width: '100px', // عرض نوار درصد
    }
})
const Text = (props) => {
    return (
        <Container>
            <div className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
            </div>
        </Container>
    );
};

class AllMarketerRequests extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = { ...MarketerBaseState };

    }

    setSelectedDayStart = (event) => {
        this.setState({ selectedDayStart: event }, () => {
            // this.filterList();
        });
    };

    setselectedDateCallback = (event) => {
        this.setState({ selectedDateCallback: event });
    };
    setSelectedDayEnd = (event) => {
        this.setState({ selectedDayEnd: event }, () => {
            // this.filterList();
        });
    };
    handleChangeDesc = (event) => {
        this.setState({ call_back_desc: event.target.value });
    };

    handleCheckboxChange = (event) => {
        // تغییر وضعیت چک‌باکس
        this.setState({ isChecked: event.target.checked ? "true" : "false" });
    };
    gotoDetailRequest = (id,call_back_desc,call_back_status,call_back_date) => {

        this.setState({ call_back_desc: call_back_desc })
        this.setState({ isChecked: call_back_status })
        if (call_back_date) {
            const [year, month, day] = call_back_date.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedDateCallback: parsedDate });
        } else {
            this.setState({ selectedDateCallback: null });
        }

        if (this.state.request_id === id) {
            this.setState({ request_id: null });
        }else {
            this.setState({ request_id: id })

        }
    }

    handleChangeCheakbox = (request_id) => {
        const { selectedDayEnd } = this.state;
        const { selectedDayStart } = this.state;
        const { call_back_desc } = this.state;
        const { isChecked } = this.state;
        const { selectedDateCallback } = this.state;

        const formatDate = ({ day, month, year }) => {
            const paddedMonth = month.toString().padStart(2, '0');
            const paddedDay = day.toString().padStart(2, '0');
            return `${year}/${paddedMonth}/${paddedDay}`;
        };

        const formattedDateCallback = formatDate(selectedDateCallback);


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {

                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }




                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_cheakbox");
        fd.append("id", request_id);
        fd.append("cheak_box_desc", call_back_desc);
        fd.append("isChecked", isChecked);
        fd.append("formattedDateCallback", formattedDateCallback);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };





    handleClick = (event, rowId) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedRowId: rowId,
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
            selectedRowId: null,
        });
    };


    handleCallStatusUpdate2 = (smsStatus) => {
        const { currentRowId ,selectedDayStart , selectedDayEnd} = this.state;


        this.handleClose(); // بستن منو

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_is_called");
        fd.append("id", currentRowId);
        fd.append("call_status_id", smsStatus);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };


    handleResendSms = (id) => {
        const { currentRowId } = this.state;


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها
                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "resend_sms");
        fd.append("excel_name", "naft");
        fd.append("id", id);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };





    handleSelectRows = (row2) => {
        this.setState(
            {
                id: row2.id,
                accident_main_coverage_name: row2.accident_main_coverage_name,
                insurer: row2.insurer,
                full_name: row2.full_name,
                typePolicy: row2.typePolicy,
                beginDate: row2.beginDate,
                endDate: row2.endDate,
                sms_date: row2.sms_date,
                excel_name: row2.excel_name,
                vehicalName: row2.vehicalName,
                plateNumber: row2.plateNumber,
                productionDate: row2.productionDate,
                policyholder: row2.policyholder,
                relation: row2.relation,
                parent_name: row2.parent_name,
                phone_number: row2.phone_number,
                personnel_no: row2.personnel_no,
                management_name: row2.management_name,
                company_name: row2.company_name,
                nationalCode: row2.nationalCode,
                message_content: row2.message_content,
                resend_sms: row2.resend_sms,
                discountFinance: row2.discountFinance,
                discountLife: row2.discountLife,
                discountDriver: row2.discountDriver,
                lastPolicyNumber: row2.lastPolicyNumber,
                policyNumber: row2.policyNumber,
                policyUniqueCode: row2.policyUniqueCode,
                engineNumber: row2.engineNumber,
                chassisNo: row2.chassisNo,
                vin: row2.vin,
                call_back_desc: row2.call_back_desc,
                call_back_date: row2.call_back_date,
                call_back_status: row2.call_back_status,
                employee_id: row2.employee_id,
                auth_id: row2.auth_id,
                is_called: row2.is_called,
                last_status: row2.last_status,
                request_id: row2.request_id,
                newAccidentMainCoverage: false,
            },
            () => {}
        )
    }




    toggleEmployeeFilter = () => {
        this.setState(prevState => ({
            isEmployeeFilterActive: !prevState.isEmployeeFilterActive
        }));
    };
    newAccidentMainCoverage = (event) => {
        this.setState({
            id: "",
            accident_main_coverage_name: "",
            insurer: "",
            newAccidentMainCoverage: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getSmsReceiver()
                        self.getSmsReceiverStatus()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getSmsReceiver = () => {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });
        this.setState({
            selectedDayEnd: "",
            selectedDayStart: "",
            selectedStatus: "",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);

                if (arr.result === "ok") {
                    // ذخیره داده‌ها در state
                    self.setState(
                        {
                            requestinfos: arr.data,
                            agentInfofilter: arr.data,
                            total: arr.total,
                        },
                        () => {
                            // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                            self.applySorting(); // مرتب‌سازی داده‌ها
                        }
                    );
                } else if (arr.result === "error") {
                    // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        };

        var fd = new FormData();
        fd.append("command", "get_all_requests");
        fd.append("limit", this.state.limit || 50); // تعداد رکورد در هر صفحه
        fd.append("offset", (this.state.page1 || 0) * (this.state.limit || 50)); //

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }


    handleCallStatusUpdate3 = (id) => {


        console.log("hey u ",id)
        window.open(`https://user.rahnamayefarda.ir/thirdparty2?id=${id}`, "_blank");

        // window.open(`http://localhost:3000/thirdparty2?id=${id}`, "_blank");



        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    getSmsReceiverStatus() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter2: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_sms_status_all")

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }



    // تابع برای اعمال مرتب‌سازی دوباره بر اساس فیلد و وضعیت مرتب‌سازی
    applySorting = () => {
        const { orderBy2, order2 } = this.state;
        const arrayTemp = [...this.state.agentInfofilter];

        // مرتب‌سازی بر اساس فیلدهای مختلف
        arrayTemp.sort((a, b) => {
            let comparisonResult = 0;

            // مقایسه داده‌ها در ترتیب اولویت
            for (let i = 0; i < orderBy2.length; i++) {
                const field = orderBy2[i];
                const orderDirection = order2[i];

                const valueA = field === 'endDate' ? new Date(a[field]) : a[field];
                const valueB = field === 'endDate' ? new Date(b[field]) : b[field];

                if (orderDirection === 'asc') {
                    comparisonResult = valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
                } else {
                    comparisonResult = valueA > valueB ? -1 : (valueA < valueB ? 1 : 0);
                }

                if (comparisonResult !== 0) break; // اگر مقایسه‌ها نتیجه‌دار شدند، دیگر مقایسه نمی‌کنیم
            }

            return comparisonResult;
        });

        // به‌روزرسانی state با داده‌های مرتب‌شده
        this.setState({ agentInfofilter: arrayTemp });
    };




    createSortHandler = (field) => {
        const { orderBy2, order2 } = this.state;

        const fieldIndex = orderBy2.indexOf(field);

        // اگر فیلد جدید است، آن را به لیست اضافه می‌کنیم
        if (fieldIndex === -1) {
            this.setState(
                {
                    orderBy2: [...orderBy2, field],
                    order2: [...order2, 'asc'], // پیش‌فرض ترتیب صعودی است
                },
                this.applySorting
            );
        } else {
            // اگر فیلد قبلاً وجود دارد، ترتیب آن را تغییر می‌دهیم
            const newOrder = [...order2];
            newOrder[fieldIndex] = newOrder[fieldIndex] === 'asc' ? 'desc' : 'asc';

            this.setState(
                {
                    order2: newOrder
                },
                this.applySorting
            );
        }
    };


    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterRows = () => {

        const { agentInfofilter, isEmployeeFilterActive, searchText } = this.state;

        return agentInfofilter
            .filter((row) => {
                if (isEmployeeFilterActive && row.employee_id !== row.auth_id) return false;

                if (!searchText.trim()) return true;

                const lowerSearch = searchText.toLowerCase();

                // چک کن ببین آیا حداقل یکی از فیلدها شامل سرچ هست
                return Object.values(row).some((value) =>
                    String(value).toLowerCase().includes(lowerSearch)
                );
            });
    };

    datafilter = () => {


        const { selectedDayStart, selectedDayEnd, searchText, selectedStatus, CustomerPhoneNumber  } = this.state;


        if (selectedDayStart && selectedDayEnd ) {
            // همه دارای مقدار هستن
            const formatDate = ({ day, month, year }) => {
                const paddedMonth = month.toString().padStart(2, '0');
                const paddedDay = day.toString().padStart(2, '0');
                return `${year}/${paddedMonth}/${paddedDay}`;
            };

            const formattedStartDate = formatDate(selectedDayStart);
            const formattedEndDate = formatDate(selectedDayEnd);
            const selectedStatusId = selectedStatus;

            // Dispatch action to show waiting state
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            });

            // استفاده از XMLHttpRequest برای ارسال داده‌ها
            var xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {  // استفاده از تابع پیکانی
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    var arr = JSON.parse(xhttp.responseText);

                    if (arr.result === "ok") {
                        // ذخیره داده‌ها در state
                        this.setState(
                            {
                                requestinfos: arr.data,
                                agentInfofilter: arr.data,
                                total: arr.total,

                            },
                            () => {
                                // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                                this.applySorting(); // مرتب‌سازی داده‌ها
                            }
                        );
                    } else if (arr.result === "error") {
                        // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                    }

                    // Dispatch action to hide waiting state
                    this.props.props.props.dispatch({
                        type: "WITEHIDE",
                    });
                }
            };

            var fd = new FormData();
            fd.append("command", "get_all_requests");
            fd.append("limit", this.state.limit || 50); // تعداد رکورد در هر صفحه
            fd.append("offset", (this.state.page1 || 0) * (this.state.limit || 50)); //
            fd.append("StartDate", formattedStartDate);
            fd.append("EndDate", formattedEndDate);
            fd.append("StatusId", selectedStatusId);
            fd.append("CustomerPhoneNumber", CustomerPhoneNumber);

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
            xhttp.send(fd);
        }else {

            this.setState({ snackstr: "لطفا تاریخ شروع و پایان را وارد کنید", showSnack: true, snackMode: "error" })

        }


    };

    render() {
        const { anchorEl } = this.state; // موقعیت منو
        const { orderBy2, order2 } = this.state;
        const { classes } = this.props
        const {
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            isEmployeeFilterActive,
            newAccidentMainCoverage,
            id,
            accident_main_coverage_name,
            searchText,
            insurer,
            full_name,
            typePolicy,
            beginDate,
            endDate,
            vehicalName,
            plateNumber,
            productionDate,
            policyholder,
            phone_number,
            nationalCode,
            message_content,
            call_back_desc,
            call_back_date,
            selectedDayEnd,
            selectedDayStart,
            selectedDateCallback,
            call_back_status,
            discountFinance,
            discountLife,
            discountDriver,
            lastPolicyNumber,
            policyNumber,
            policyUniqueCode,
            engineNumber,
            is_called,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            agentInfofilter2,
            rowsPerPage,
            page,
            page1,
            cheak_box_desc,

        } = this.state

        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="xl">

                                <FilterPanel
                                    className={classes.root}
                                    searchText={this.state.searchText}
                                    onSearchTextChange={(val) => this.setState({ searchText: val })}
                                    selectedDayStart={this.state.selectedDayStart}
                                    onStartDateChange={(val) => this.setState({ selectedDayStart: val })}
                                    selectedDayEnd={this.state.selectedDayEnd}
                                    onEndDateChange={(val) => this.setState({ selectedDayEnd: val })}
                                    selectedStatus={this.state.selectedStatus}
                                    onStatusChange={(val) => this.setState({ selectedStatus: val })}
                                    statusOptions={agentInfofilter2.map(item => ({
                                        value: item.sms_status_id,
                                        label: item.sms_status
                                    }))}
                                    CustomerPhoneNumber={this.state.CustomerPhoneNumber}
                                    onCustomerPhoneNumberChange={(val) => this.setState({ CustomerPhoneNumber: val })}
                                    onSearch={this.datafilter}
                                    onBase={this.getSmsReceiver}
                                    excel='Marketer'
                                    filter='ALL'
                                />

                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "id" ? order : false}
                                                    >
                                                        {"آیدی "}
                                                        <TableSortLabel
                                                            active={orderBy === "id"}
                                                            direction={
                                                                orderBy === "id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"insurer"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه"}
                                                        <TableSortLabel
                                                            active={orderBy === "insurer"}
                                                            direction={
                                                                orderBy === "insurer" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("insurer")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"typePolicy"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"typePolicy"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "typePolicy"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "typePolicy" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("typePolicy")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell*/}
                                                    {/* key={"beginDate"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"beginDate"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "beginDate"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "beginDate" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("beginDate")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"endDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ پایان"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("endDate")}
                                                            direction={orderBy2.includes("endDate") ? order2[orderBy2.indexOf("endDate")] : "asc"}
                                                            onClick={() => this.createSortHandler("endDate")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"sms_date"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ ارجاع"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("sms_date")}
                                                            direction={orderBy2.includes("sms_date") ? order2[orderBy2.indexOf("sms_date")] : "asc"}
                                                            onClick={() => this.createSortHandler("sms_date")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"excel_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام اکسل"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("excel_name")}
                                                            direction={orderBy2.includes("excel_name") ? order2[orderBy2.indexOf("excel_name")] : "asc"}
                                                            onClick={() => this.createSortHandler("excel_name")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"plateNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پلاک ماشین"}
                                                        <TableSortLabel
                                                            active={orderBy === "plateNumber"}
                                                            direction={
                                                                orderBy === "plateNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("plateNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyholder"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام/نام خانوادگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyholder"}
                                                            direction={
                                                                orderBy === "policyholder" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyholder")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"phone_number"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موبایل"}
                                                        <TableSortLabel
                                                            active={orderBy === "phone_number"}
                                                            direction={
                                                                orderBy === "phone_number" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("phone_number")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"nationalCode"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"nationalCode"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "nationalCode"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "nationalCode" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("nationalCode")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"message_content"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"متن پیامک"}
                                                        <TableSortLabel
                                                            active={orderBy === "message_content"}
                                                            direction={
                                                                orderBy === "message_content" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("message_content")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/*    key={"resend_sms"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"پیامک مجدد"}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "resend_sms"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "resend_sms" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("resend_sms")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"call_back_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تماس مجدد"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("call_back_status")}
                                                            direction={orderBy2.includes("call_back_status") ? order2[orderBy2.indexOf("call_back_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("call_back_status")}
                                                        />
                                                    </TableCell>




                                                    <TableCell
                                                        key={"is_called"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تعیین وضعیت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "is_called"}
                                                            direction={
                                                                orderBy === "is_called" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("is_called")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"آخرین وضعیت"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("last_status")}
                                                            direction={orderBy2.includes("last_status") ? order2[orderBy2.indexOf("last_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("last_status")}
                                                        />
                                                    </TableCell>

                                                    <TableCell
                                                        key={"price"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"قیمت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "price"}
                                                            direction={
                                                                orderBy === "price" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("price")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {/*<div>*/}
                                                {/*    /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                {/*    <Button*/}
                                                {/*        variant="contained"*/}
                                                {/*        color="primary"*/}
                                                {/*        onClick={this.toggleEmployeeFilter}*/}
                                                {/*    >*/}
                                                {/*        {isEmployeeFilterActive ? 'غیرفعال کردن فیلتر' : 'فعال کردن فیلتر'}*/}
                                                {/*    </Button>*/}
                                                {/*</div>*/}


                                                {this.filterRows()
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        if (isEmployeeFilterActive && row.employee_id !== row.auth_id) {
                                                            return null;
                                                        }
                                                        const color = row.percentage < 50 ? 'red' : row.percentage < 80 ? 'yellow' : 'green';
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.
                                                                    gotoDetailRequest(row.id,row.call_back_desc,row.call_back_status,row.call_back_date)
                                                                }}
                                                                style={{
                                                                    backgroundColor:
                                                                        row.last_status === "در حال بررسی"
                                                                            ? "#F5F5DC" // زرد کرمی
                                                                            : row.last_status === "تمدید شد"
                                                                                ? "#EAF3FB" // سبز ملایم
                                                                                : row.last_status === "بررسی نشده"
                                                                                    ? "#FDEDEC" // قرمز ملایم
                                                                                    : row.last_status === "نهایی شد"
                                                                                        ? "#E6F4EA" // سبز نعناعی ملایم
                                                                                        : "transparent",

                                                                    transition: "background-color 0.3s ease",
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"insurer"}
                                                                    align={"center"}
                                                                >
                                                                    {row["insurer"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"typePolicy"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["typePolicy"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/* key={"beginDate"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["beginDate"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"endDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["endDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"sms_date"}
                                                                    align={"center"}
                                                                >
                                                                    {row["sms_date"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"excel_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["excel_name"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"vehicalName"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["vehicalName"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"plateNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["plateNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyholder"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyholder"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"phone_number"}
                                                                    align={"center"}
                                                                >
                                                                    {row["phone_number"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"message_content"}
                                                                    align={"center"}
                                                                >
                                                                    {row["message_content"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/*    key={"resend_sms"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    /!*{row["resend_sms"]}*!/*/}
                                                                {/*    <div>*/}
                                                                {/*        /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                                {/*        <Button*/}
                                                                {/*            variant="contained"*/}
                                                                {/*            color="primary"*/}
                                                                {/*            disabled={row["resend_sms"] == 1 || row["excel_name"] == 'مشتری های قدیمی' }*/}

                                                                {/*            onClick={(event) => {*/}
                                                                {/*                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک*/}
                                                                {/*                this.handleResendSms(row.id);*/}
                                                                {/*            }}*/}

                                                                {/*        >*/}

                                                                {/*            پیامک مجدد*/}
                                                                {/*        </Button>*/}
                                                                {/*    </div>*/}


                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"call_back_desc"}
                                                                    align={"center"}
                                                                    style={{
                                                                        backgroundColor: row["call_back_status"] === "true" ? "green" : "transparent", // سبز در حالت true
                                                                        color: row["call_back_status"] === "true" ? "white" : "inherit", // متن سفید فقط در حالت true
                                                                    }}
                                                                >
                                                                    {/*{row["call_back_status"] === "true" ? "بله" : "خیر"}*/}
                                                                    <br />
                                                                    {row["call_back_date"]}
                                                                </TableCell>




                                                                <TableCell align="center">
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={(event) => this.handleClick(event, row.id)}
                                                                    >
                                                                        انتخاب وضعیت
                                                                    </Button>

                                                                    {this.state.selectedRowId === row.id && (
                                                                        <Menu
                                                                            anchorEl={this.state.anchorEl}
                                                                            open={Boolean(this.state.anchorEl)}
                                                                            onClose={this.handleClose}

                                                                            TransitionComponent={Grow}
                                                                            TransitionProps={{ timeout: 600 }} // برای زمان انیمیشن

                                                                        >
                                                                            {agentInfofilter2.map((item, index) => (
                                                                                <MenuItem
                                                                                    key={index}
                                                                                    onClick={(event) => {
                                                                                        event.stopPropagation();
                                                                                        this.setState({ currentRowId: row.id }, () => {
                                                                                            this.handleCallStatusUpdate2(item.sms_status_id);
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    {item.sms_status}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Menu>
                                                                    )}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {row["last_status"]}
                                                                    {<h5> ({row["full_name"]}) </h5>}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"price"}
                                                                    align={"center"}
                                                                >


                                                                    <div>
                                                                        {/* دکمه برای فعال/غیرفعال کردن شرط */}
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"

                                                                            onClick={(event) => {
                                                                                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک
                                                                                this.handleCallStatusUpdate3(row.id);
                                                                            }}
                                                                            disabled
                                                                        >


                                                                            قیمت$
                                                                        </Button>
                                                                    </div>

                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        // rowsPerPageOptions={[10, 25, 100]}
                                        rowsPerPageOptions={[50]}
                                        component="div"
                                        count={this.filterRows().length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />

                                    <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
                                        <Pagination
                                            count={Math.ceil(this.state.total / this.state.limit)}
                                            page={this.state.page1 + 1}
                                            onChange={(event, value) => {
                                                this.setState({ page1: value - 1 }, () => {
                                                    const { selectedDayStart, selectedDayEnd } = this.state;
                                                    if (selectedDayStart && selectedDayEnd) {
                                                        this.datafilter();
                                                    } else {
                                                        this.getSmsReceiver();
                                                    }
                                                });
                                            }}
                                            color="primary"
                                            shape="rounded"
                                            variant="outlined"
                                        />
                                    </div>

                                </Paper>
                            </Container>

                            <Container component="main" maxWidth="lg">

                                <Container maxWidth="lg">
                                    {agentInfofilter
                                        .map((row) => {
                                            const color = this.state['request_id'];
                                            if (color === row.id) {
                                                return (
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="vertical table">
                                                            <TableBody style={{ textAlign: "center" , direction: "rtl",}}>
                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گر</TableCell> {/* insurer */}
                                                                    <TableCell align="center">{row.insurer}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نوع بیمه‌نامه</TableCell> {/* typePolicy */}
                                                                    <TableCell align="center">{row.typePolicy}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تاریخ شروع</TableCell> {/* beginDate */}
                                                                    <TableCell align="center">{row.beginDate}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام خودرو</TableCell> {/* vehicalName */}
                                                                    <TableCell align="center">{row.vehicalName}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پلاک</TableCell> {/* plateNumber */}
                                                                    <TableCell align="center">{row.plateNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">سال خودرو</TableCell> {/* plateNumber */}
                                                                    <TableCell align="center">{row.productionDate}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نسبت با سرپرست</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.relation}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام سرپرست (در صورت وجود)</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.parent_name}</TableCell>
                                                                </TableRow>


                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گذار</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.policyholder}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موبایل</TableCell> {/* phone_number */}
                                                                    <TableCell align="center">{row.phone_number}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پرسنلی</TableCell> {/* personnel_no */}
                                                                    <TableCell align="center">{row.personnel_no}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام مدیریت</TableCell> {/* management_name */}
                                                                    <TableCell align="center">{row.management_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام شرکت</TableCell> {/* company_name */}
                                                                    <TableCell align="center">{row.company_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد ملی</TableCell> {/* nationalCode */}
                                                                    <TableCell align="center">{row.nationalCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف مالی</TableCell> {/* discountFinance */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountFinance"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountFinance"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                } />
                                                                        </div>
                                                                        {row["discountFinance"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف جانی</TableCell> {/* discountLife */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountLife"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountLife"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountLife"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف راننده</TableCell> {/* discountDriver */}
                                                                    <TableCell style={{ textAlign: "-webkit-center", direction: "rtl" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountDriver"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountDriver"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountDriver"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه قبلی</TableCell> {/* lastPolicyNumber */}
                                                                    <TableCell align="center">{row.lastPolicyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه</TableCell> {/* policyNumber */}
                                                                    <TableCell align="center">{row.policyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد یکتای بیمه‌نامه</TableCell> {/* policyUniqueCode */}
                                                                    <TableCell align="center">{row.policyUniqueCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موتور</TableCell> {/* engineNumber */}
                                                                    <TableCell align="center">{row.engineNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره شاسی</TableCell> {/* chassisNo */}
                                                                    <TableCell align="center">{row.chassisNo}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد VIN</TableCell> {/* vin */}
                                                                    <TableCell align="center">{row.vin}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">توضیح تماس بعدی</TableCell> {/* Call back */}
                                                                    <TableCell align="center">{row.call_back_desc}</TableCell>
                                                                </TableRow>

                                                            </TableBody>
                                                        </Table>



                                                    </TableContainer>




                                                )
                                            }

                                        })}




                                </Container>

                            </Container>
                        </Grid>
                    </Grid>


                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>


            )
        }
    }
}

export default withStyles(styles)(AllMarketerRequests)
